// TanStack Query client global. Reemplazará gradualmente a SWR.
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 min "fresco"
      gcTime: 5 * 60 * 1000, // 5 min en cache tras desmontar
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
  },
});
